import ErrorToast from "@components/Common/ErrorTost";
import React from "react";
import { useTranslation } from "react-i18next";

type Params = {
    userID: number;
    franchiseID: string;
    shopId: string;
    saleBO: string[];
    fetchGlobal: (url: string, options: RequestInit) => Promise<any>;
    setSortedVisibility: (modes: any[]) => void;
};

export function useFetchModeOfSale(params: Params) {
    const { t } = useTranslation();
    const {
        userID,
        franchiseID,
        shopId,
        saleBO,
        fetchGlobal,
        setSortedVisibility,
    } = params;

    return React.useCallback(async () => {
        const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`;

        try {
            const response: any = await fetchGlobal(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": i18nextLng,
                },
            });

            const saleModes = response.data.map((saleMode: any) => ({
                designation: saleMode["Mode of sale"],
                state: false,
                saleSupports: saleMode.support_vente.map((el: any) => ({
                    designation: el,
                    state: false,
                })),
            }));

            setSortedVisibility(
                saleModes.filter((el: any) => saleBO.includes(el.designation))
            );
        } catch (error) {
            ErrorToast(t("Mistake ! Please try again"));
        }
        // Why: deps track the URL inputs only. `fetchGlobal`/`setSortedVisibility`/`t`
        // are excluded to keep the callback stable. NOTE: `saleBO` is also excluded —
        // if it changes between calls, the filter at l.48 will use the closure value
        // captured on first creation. Currently safe because the parent passes `saleBO`
        // as a constant array. To revisit if `saleBO` becomes dynamic.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userID, franchiseID, shopId]);
}
